import { WorkShopFormPartial } from "../../../../../partials";
import { useNavigate } from "react-router-dom";

export const InteractiveWorkshopView = () => {
  const navigate = useNavigate();
  return (
    <div>
      <WorkShopFormPartial
        method="POST"
        onSave={(values) => {
          navigate("/workshops");
        }}
      />
    </div>
  );
};
export const InteractiveWorkshopRoute = "/admin/workshops/interactive-workshop";
